import React, { FormEvent, ReactElement } from 'react';
import {
  FormGroup, Heading, Label, Loader, Select,
} from 'idsk-react-components';
import { OrganizacnaSkupinaEnum } from 'ciselniky-frontend-ts-axios';
import { SafeParameterSetter } from '../../../../model/types/SafeParameterSetter';
import PrispevokVestnika from '../../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../../model/PrispevokVestnikaStepEnum';
import useOrganizacie from '../../../../hooks/useOrganizacie';
import UserRole from '../../../../model/currentuser/UserRole';
import Secured from '../../../Secured';
import ImporterAutor from './component/ImporterAutor';
import BasicDataStep1Component from './component/BasicDataStep1Component';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onSubmit: (e: FormEvent<HTMLFormElement>, activeStep: PrispevokVestnikaStepEnum) => void;
  onUpdateField: SafeParameterSetter<PrispevokVestnika>;
  loading?: boolean;
  getFieldErrorMessage: (fieldName: string) => string;
}

const BasicDataStep1Create = ({
  onSubmit,
  onUpdateField,
  prispevokVestnika,
  loading = false,
  getFieldErrorMessage,
}: Props): ReactElement => {
  const {
    organizacie: organizaciaList,
    organizacieStatus: organizaciaListStatus,
  } = useOrganizacie(OrganizacnaSkupinaEnum.Vestnik);

  return (
    <div className="prispevok-vestnika-step-pages">
      <Heading className="page-title" size="xl">
        Vyplňte základné údaje
      </Heading>
      <Loader loading={organizaciaListStatus.loading}>
        <Secured
          allowForRoles={[UserRole.REZORTNE_ZBIERKY_SPRAVCA]}
          elseChildren={(
            <ImporterAutor
              onUpdateField={onUpdateField}
            />
          )}
        >
          <>
            <FormGroup error={!!getFieldErrorMessage('vestnik')}>
              <Label htmlFor="vestnik">Autor príspevku</Label>
              <Select
                id="vestnik"
                width="three-quarters"
                name="vestnikUuid"
                value={prispevokVestnika.vestnik.uuid}
                onChange={({ target }) => {
                  const selectedVestnik = organizaciaList.find(vestnik => vestnik.uuid === target.value);
                  onUpdateField('vestnik', selectedVestnik);
                  onUpdateField('rusiPrispevky', []);
                  onUpdateField('meniPrispevky', []);
                }}
                error={getFieldErrorMessage('vestnik')}
              >
                <option key="Vyberte" value="" hidden>Vyberte</option>
                {(organizaciaList && organizaciaList?.length > 0) ? (
                  <>
                    {organizaciaList
                      ?.map(vestnik => (
                        <option
                          key={vestnik.uuid}
                          value={vestnik.uuid}
                        >
                          {vestnik.skratenyNazov}
                        </option>
                      ))}
                  </>
                ) : (
                  <option key="emptyOption" value="emptyOption" disabled>
                    Nenašiel sa žiadny záznam.
                  </option>
                )}
              </Select>
            </FormGroup>
            <FormGroup className="priloha-vestnika-create-form-group__disabled">
              <Label htmlFor="vestnikDisabled">Vestník</Label>
              <Select
                id="vestnikDisabled"
                width="three-quarters"
                name="vestnikDisabled"
                value={prispevokVestnika.vestnik.uuid}
                disabled
              >
                <option key="Vyberte" value="" hidden aria-label="Vyberte">&nbsp;</option>
                {(organizaciaList && organizaciaList?.length > 0) ? (
                  <>
                    {organizaciaList
                      ?.map(vestnik => (
                        <option
                          key={vestnik.uuid}
                          value={vestnik.uuid}
                        >
                          {vestnik.nazov}
                        </option>
                      ))}
                  </>
                ) : (
                  <option key="emptyOption" value="emptyOption" disabled>
                    Nenašiel sa žiadny záznam.
                  </option>
                )}
              </Select>
            </FormGroup>
          </>
        </Secured>
      </Loader>
      <BasicDataStep1Component
        prispevokVestnika={prispevokVestnika}
        onSubmit={onSubmit}
        onUpdateField={onUpdateField}
        getFieldErrorMessage={getFieldErrorMessage}
        loading={loading}
      />
    </div>
  );
};

export default BasicDataStep1Create;
